import React from "react";
import companiesImg from "../../Assets/companies.svg";

function CompanyImg() {
  return <img className="companyImg" src={companiesImg} alt="" />;
}

export default CompanyImg;
